(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complete-the-look-js"] && !Shopify.designMode) return;
  try {
    (function (root) {

  /**
   * Debug mode flag — defaults to false.
   * Override via `window.CTL_DEBUG_MODE = true` before `bindAllVariants()` 
   * or call `CompleteTheLookUtils.setDebugMode(true)`.
   */
  let debugMode = true;

  function logDebug(label, data) {
    if (!debugMode) return;
    console.log(`[CompleteTheLookUtils] ${label}:`, data);
  }

  function triggerEvent(el, eventType, detail) {
    if (!el) return;
    const event = new CustomEvent(eventType, { 
      bubbles: true, 
      detail: detail || {} 
    });
    el.dispatchEvent(event);
  }

  /**
   * Finds the variant select for a card.
   */
  function findSelector($cardParent) {
    if (!$cardParent) return null;

    return $cardParent.querySelector('.complete-the-look__variant-select') || null;
  }

  /**
   * Updates a hidden <select> field inside a product card,
   * based on the selected radio button within that same card.
   *
   * Handles multiple independent radio groups (e.g., Color + Size) by:
   * 1. Collecting the currently selected value from each radio group (by data-name)
   * 2. Combining them (e.g., "Black / S") to match data-options on <option>
   * 3. Selecting the matching option that is NOT disabled
   *
   * @param {HTMLElement} $radio       - The clicked radio button
   * @param {HTMLElement} $cardParent  - The product card wrapper (`.complete-the-look__item`)
   * @param {HTMLElement} $selector    - The hidden select field within that card
   */
  function updateQuickViewVariantsSelector($radio, $cardParent, $selector) {
    if (!$radio || !$cardParent || !$selector) return;

    const radioValue = $radio.value;
    const radioName = $radio.getAttribute('data-name');
    const selectorId = $selector.id || 'unknown';

    const variantImage = $radio.getAttribute('data-variant-image');
    const variantImageSrcset = $radio.getAttribute('data-variant-image-srcset');
    
    if (variantImage && radioName === 'color') {
      const $target = $cardParent.querySelector('.complete-the-look__image-link .complete-the-look__image');

      if ($target && $target.tagName === 'IMG') {
        $target.setAttribute('src', variantImage);
        $target.setAttribute('srcset', variantImageSrcset);
        $target.dispatchEvent(new Event('load', { bubbles: true }));
      }
    }

    // Read the currently selected radio value for each option group.
    const allRadios = $cardParent.querySelectorAll(
      '.ctl-select-option'
    );

    const selectedByGroup = {}; // keyed by data-name (e.g., 'color', 'size')

    allRadios.forEach(function(r) {
      if (!r.checked) return;
      const groupName = r.getAttribute('data-name');
      if (!groupName) return;

      const v = r.getAttribute('data-value') || r.value;

      // Keep the more specific color selection when a group is duplicated.
      if (!selectedByGroup[groupName] || groupName === 'color') {
        selectedByGroup[groupName] = v;
      }
    });

    // When multiple groups are selected, combine them into the variant string used by the hidden select.
    const groupKeys = Object.keys(selectedByGroup);

    let combinedOptionValue = null;
    let matchedSelectOption = null;

    if (groupKeys.length >= 2) {
      const sortedKeys = groupKeys.sort(); // sort for consistency: ['color', 'size']
      const parts = sortedKeys.map(function(key) { return selectedByGroup[key]; });
      combinedOptionValue = parts.join(' / ');

      // Match the combined option string against the hidden select’s data-options values.
      const options = $selector.querySelectorAll('option');
      for (let i = 0; i < options.length; i++) {
        const opt = options[i];
        const dataOptions = opt.getAttribute('data-options');

        if (opt.hasAttribute('disabled') || opt.getAttribute('disabled') === 'true') {
          continue;
        }

        if (dataOptions && dataOptions.trim() === combinedOptionValue) {
          matchedSelectOption = opt;
          break; // Take first non-disabled match (highest priority variant)
        }
      }

      if (matchedSelectOption) {
        const previousValue = $selector.value;
        $selector.value = matchedSelectOption.value;

        const $comparePrice = $cardParent.querySelector('[data-compare-price-ctl]');
        if ($comparePrice) {
          $comparePrice.innerHTML = matchedSelectOption.getAttribute('data-was-price');
        }

        const $productPrice = $cardParent.querySelector('[data-product-price-ctl]');
        if ($productPrice) {
          $productPrice.innerHTML = matchedSelectOption.getAttribute('data-current-price');
        }

        // Reflect the selection on the option nodes as well as on the select value.
        options.forEach(function(o) { o.selected = false; });
        matchedSelectOption.selected = true;

        // Dispatch both native events so external listeners stay in sync.
        $selector.dispatchEvent(new Event('change', { bubbles: true }));
        $selector.dispatchEvent(new Event('input', { bubbles: true }));

        return;
      } else {
      }
    }

    // Fall back to the radio’s raw value when the combined group lookup misses.
    const previousValue = $selector.value;
    const options = $selector.options || [];

    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (option.hasAttribute('disabled') || option.getAttribute('disabled') === 'true') {
        continue;
      }
      const wasSelected = option.selected;
      option.selected = (option.value === radioValue);
      const nowSelected = option.selected;

    }

    // Set the select value explicitly for browser-specific consumers.
    $selector.value = radioValue;

    // Dispatch a native change event so the shop code sees the same behavior as a regular select.
    const nativeChangeEvent = new Event('change', { bubbles: true });
    $selector.dispatchEvent(nativeChangeEvent);

    // Dispatch the corresponding input event as well.
    const nativeInputEvent = new Event('input', { bubbles: true });
    $selector.dispatchEvent(nativeInputEvent);
  }

  /**
   * Bind a card’s radios to its hidden variant select.
   *
   * @param {Object} options
   * @param {HTMLElement} options.$cardParent - The product card wrapper
   * @param {string} options.radioSelector - Selector for the radios in the card
   */
  function bindVariantsPerCard(options) {
    if (!options || !options.$cardParent) return;

    const defaults = {
      radioSelector: '.ctl-select-option'
    };

    const settings = Object.assign({}, defaults, options);
    const cardParent = options.$cardParent;
    const selector = findSelector(cardParent);
    const radios = cardParent.querySelectorAll(settings.radioSelector);

    let changeHandler = function(e, $cardParent) {
      const $radio = e.currentTarget;
      const $selector = findSelector($cardParent);

      if ($selector) {
        updateQuickViewVariantsSelector($radio, cardParent, $selector);
      }
    };

    radios.forEach(function(el) {
      el.addEventListener('change', function(e) { changeHandler(e, cardParent); });
    });

    return {
      update: function ($radio) {
        const $selector = findSelector(cardParent);
        if ($radio && $selector) {
          updateQuickViewVariantsSelector($radio, cardParent, $selector);
        }
      },
      settings: settings,
      destroy: function() {
        const radios = cardParent.querySelectorAll(settings.radioSelector);
        radios.forEach(function(el) {
          el.removeEventListener('change', changeHandler);
        });
      }
    };
  }

  /**
   * Bind the variant radios for every complete-the-look card on the page.
   */
  function bindAllVariants() {
    const cards = document.querySelectorAll('.complete-the-look .complete-the-look__item');

    if (cards.length === 0) {
      return;
    }

    const bindings = [];

    cards.forEach(function(cardEl) {
      const binding = bindVariantsPerCard({
        $cardParent: cardEl,
        radioSelector: '.ctl-select-option'
      });

      if (binding) {
        bindings.push(binding);
      }
    });

    return {
      update: function ($radio) {
        const $card = $radio.closest('.complete-the-look__item');
        if ($card) {
          const $selector = findSelector($card);
          if ($selector) {
            updateQuickViewVariantsSelector($radio, $card, $selector);
          }
        }
      },
      bindings: bindings
    };
  }

  // Public surface for consumers and manual invocation.
  root.CompleteTheLookUtils = {
    bindAllVariants: bindAllVariants,
    bindVariantsPerCard: bindVariantsPerCard,
    updateSelector: updateQuickViewVariantsSelector,
    findSelector: findSelector,

    /**
     * Enable or disable debug logging.
     * @param {boolean} enable - true to enable, false to disable
     */
    setDebugMode: function (enable) {
      debugMode = !!enable;
      if (debugMode) {
        console.log('[CompleteTheLookUtils] Debug mode ENABLED');
      } else {
        console.log('[CompleteTheLookUtils] Debug mode DISABLED — all logDebug calls are silent.');
      }
    },

    /**
     * Check if debug mode is currently enabled.
     * @returns {boolean}
     */
    isDebugMode: function () {
      return debugMode;
    }
  };

})(typeof window !== 'undefined' ? window : this);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["complete-the-look"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    CompleteTheLookUtils.bindAllVariants();
  });
  } catch(e) { console.error(e); }
})();

})();
